module.exports = __webpack_public_path__ + "img/06.266ee962.jpg";